import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "message-list dashboard-card" }
const _hoisted_2 = { class: "card-title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "me-2" }, " Unread Messages ", -1 /* HOISTED */)
const _hoisted_4 = { class: "me-2" }
const _hoisted_5 = {
  tabindex: "0",
  href: "javascript:void(0);",
  role: "button"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-primary" }, null, -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "ms-auto d-flex align-items-center cursor-pointer" }
const _hoisted_9 = { class: "icon small" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar-alt" }, null, -1 /* HOISTED */)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text font-size-sm fw-bold me-2 blue-text" }, "Sort", -1 /* HOISTED */)
const _hoisted_12 = { class: "message-data" }
const _hoisted_13 = { class: "d-flex" }
const _hoisted_14 = { class: "fw-bold" }
const _hoisted_15 = { class: "ms-auto me-1 font-size-xs" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "d-flex flex-row align-items-center" }
const _hoisted_18 = { class: "text-default ms-2 font-size-2xs" }
const _hoisted_19 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-pulse fa-fw" }, null, -1 /* HOISTED */)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("b", { class: "mx-2" }, "Loading your Messages", -1 /* HOISTED */)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-pulse fa-fw" }, null, -1 /* HOISTED */)
const _hoisted_23 = [
  _hoisted_20,
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = {
  key: 1,
  class: "error-state"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("There was a problem while fetching your messages."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Please try again.")
], -1 /* HOISTED */)
const _hoisted_26 = {
  key: 1,
  class: "no-data"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", null, "You have no new messages.", -1 /* HOISTED */)
const _hoisted_28 = [
  _hoisted_27
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductPill = _resolveComponent("ProductPill")!
  const _component_ScrollPagination = _resolveComponent("ScrollPagination")!
  const _component_CardTemplate = _resolveComponent("CardTemplate")!
  const _directive_custom_popover = _resolveDirective("custom-popover")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CardTemplate, { "border-class": "message-section msglist-ipadding" }, {
      header: _withCtx(() => [
        _createElementVNode("section", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, " (" + _toDisplayString(_ctx.myMessagesTotal) + ") ", 1 /* TEXT */),
          _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_5, _hoisted_7)), [
            [_directive_custom_popover, {
                            content: _ctx.tooltip,
                            placement: 'left',
                            className: 'w-25 font-size-sm info-popup'
                        }]
          ])
        ]),
        _createElementVNode("section", _hoisted_8, [
          _withDirectives((_openBlock(), _createElementBlock("div", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sortByScheduleDate())),
            class: "d-flex flex-column align-items-center"
          }, [
            _createElementVNode("span", _hoisted_9, [
              _createElementVNode("i", {
                class: _normalizeClass(_ctx.isAscending ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up')
              }, null, 2 /* CLASS */),
              _hoisted_10
            ]),
            _hoisted_11
          ])), [
            [_vShow, _ctx.myMessagesList.length],
            [_directive_tooltip, { title: `Click to sort messages by date.` }]
          ])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode(_component_ScrollPagination, {
          class: "w-100 h-100",
          "page-number": _ctx.pageNumber,
          "all-pages-loaded": _ctx.allPagesLoaded,
          "is-loading": _ctx.isLoading,
          "has-error": _ctx.hasError,
          onPageNumberUpdate: _ctx.pageNumberUpdated
        }, {
          default: _withCtx(() => [
            (_ctx.myMessagesTotal > 0)
              ? (_openBlock(), _createElementBlock("section", {
                  key: 0,
                  class: _normalizeClass(["d-flex flex-column flex-nowrap w-100 h-100 overflow-auto scroll-paginate", `${!_ctx.isNewScroll ? '' : _ctx.userOs == 'Windows' ? 'custom-scrollbar' : ''}`])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.myMessagesList, (message) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: message.Id,
                      class: "router-message"
                    }, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("span", _hoisted_14, _toDisplayString(message.FromName), 1 /* TEXT */),
                          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.formatDate(message.Sent, "MM/DD/YY")), 1 /* TEXT */)
                        ]),
                        _createElementVNode("a", {
                          class: "subject",
                          href: "javascript:void(0);",
                          onClick: ($event: any) => (_ctx.viewMessage(message))
                        }, _toDisplayString(message.Subject), 9 /* TEXT, PROPS */, _hoisted_16),
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_ProductPill, {
                            class: "application-name",
                            "product-id": _ctx.getApplicationId(message.Application)
                          }, null, 8 /* PROPS */, ["product-id"]),
                          _createElementVNode("span", _hoisted_18, _toDisplayString(message.AgencyName), 1 /* TEXT */)
                        ])
                      ])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */)),
                  _createCommentVNode(" LOADING "),
                  (!_ctx.hasError && _ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_23))
                    : _createCommentVNode("v-if", true),
                  _createCommentVNode(" ERROR "),
                  (_ctx.hasError && !_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _hoisted_25,
                        _createElementVNode("button", {
                          class: "btn btn-primary",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getData()))
                        }, "Try Again")
                      ]))
                    : _createCommentVNode("v-if", true)
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" NO DATA "),
            (_ctx.myMessagesTotal == 0 && !_ctx.isLoading && !_ctx.hasError)
              ? (_openBlock(), _createElementBlock("p", _hoisted_26, _hoisted_28))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["page-number", "all-pages-loaded", "is-loading", "has-error", "onPageNumberUpdate"])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}